import { createFeature, createReducer, on } from '@ngrx/store';

import {
  ReportActions,
  SurveyPerformanceReportActions,
} from '../actions/report.actions';
import { ReportState } from '../report-state.model';

const initialState: ReportState = {
  reports: [],
  statuses: [],
  isLoading: false,
  isRequesting: false,
  error: null,
  surveyPerformance: {
    results: [],
    buyers: [],
    isLoadingResults: false,
    isLoadingBuyers: false,
    error: null,
  },
};

export const reportFeature = createFeature({
  name: 'report',
  reducer: createReducer<ReportState>(
    initialState,

    on(ReportActions.loadReports, (state) => ({
      ...state,
      isLoading: true,
      error: null,
    })),
    on(ReportActions.loadReportsSuccess, (state, { reports }) => ({
      ...state,
      isLoading: false,
      reports,
    })),
    on(ReportActions.loadReportsFailure, (state, { error }) => ({
      ...state,
      isLoading: false,
      error,
    })),
    on(ReportActions.loadStatusesSuccess, (state, { statuses }) => ({
      ...state,
      statuses,
    })),
    on(ReportActions.loadStatusesFailure, (state, { error }) => ({
      ...state,
      error,
    })),
    on(ReportActions.requestReport, (state) => ({
      ...state,
      isRequesting: true,
      error: null,
    })),
    on(ReportActions.requestReportSuccess, (state) => ({
      ...state,
      isRequesting: false,
    })),
    on(ReportActions.requestReportFailure, (state, { error }) => ({
      ...state,
      isRequesting: false,
      error,
    })),
    on(ReportActions.downloadReportFailure, (state, { error }) => ({
      ...state,
      error,
    })),
    on(ReportActions.downloadUserActivityReportFailure, (state, { error }) => ({
      ...state,
      error,
    })),

    on(SurveyPerformanceReportActions.loadBuyers, (state) => ({
      ...state,
      surveyPerformance: {
        ...state.surveyPerformance,
        isLoadingBuyers: true,
        error: null,
      },
    })),
    on(
      SurveyPerformanceReportActions.loadBuyersSuccess,
      (state, { buyers }) => ({
        ...state,
        surveyPerformance: {
          ...state.surveyPerformance,
          isLoadingBuyers: false,
          buyers,
        },
      }),
    ),
    on(
      SurveyPerformanceReportActions.loadBuyersFailure,
      (state, { error }) => ({
        ...state,
        surveyPerformance: {
          ...state.surveyPerformance,
          isLoadingBuyers: false,
          error,
        },
      }),
    ),
    on(SurveyPerformanceReportActions.loadResults, (state) => ({
      ...state,
      surveyPerformance: {
        ...state.surveyPerformance,
        isLoadingResults: true,
        error: null,
      },
    })),
    on(
      SurveyPerformanceReportActions.loadResultsSuccess,
      (state, { results }) => ({
        ...state,
        surveyPerformance: {
          ...state.surveyPerformance,
          isLoadingResults: false,
          results,
        },
      }),
    ),
    on(
      SurveyPerformanceReportActions.loadResultsFailure,
      (state, { error }) => ({
        ...state,
        surveyPerformance: {
          ...state.surveyPerformance,
          isLoadingResults: false,
          error,
        },
      }),
    ),
  ),
});
